import React from 'react';
import { connect } from 'react-redux';
import { IDataStorage, Translate } from '../../core';
import { Button, Column, DataTable, Dialog, Steps } from '../prime';
import { Alert, Forms, Loader } from '..';
import { IFileContent } from '../../services/api/services/model';
import API from '../../services/api';
import { ImportActionsMS, ImportFinal, ImportResult, ImportResultFinal } from '../../services/api/importador/model/importer.model';
import styles from './index.module.scss';
import { saveAs } from 'file-saver';

const DiccionaryKey = 'components/importer';


export enum EntidadesImportables {
//  Pais = "Pais",
  ProductoPais = "ProductoPais",
  ProductoRegion = "ProductoRegion",
  ProductoSegmento = "ProductoSegmento",
  ProductoPrestacion = "ProductoPrestacion",
  ProductoPrecio = "ProductoPrecio",
  CotizacionVendedor = "CotizacionVendedor",
  OperacionVendedor = "OperacionVendedor",
  OperacionFacturas = "OperacionFacturas",
  LoteFacturacionFacturas = "LoteFacturacionFacturas",
  EmisionGrupal = "EmisionGrupal",
}

enum Step {
  LoadFile,
  LoadingFile,
  ShowImported,
  Processing,
  Result
}

interface IProps {
  storage?: IDataStorage;

  /** Entidad que se está importando */
  entity?: EntidadesImportables;

  /** información extra para el proceso */
  extraData?: any;

  /** muestra u oculta el importador */
  visible?: boolean;

  /** indica si se muestra el botón de descarga de archivo de ejemplo */
  hideDownloadExample?: boolean;

  /** sobreescribe el método de descarga del archivo de ejemplo */
  overrideOnDownloadExample?: (entity?: EntidadesImportables, extraData?: any) => void;

  onHide: (imported?: boolean) => void;
}

interface IState {
  storage?: IDataStorage;

  entity?: EntidadesImportables;

  extraData?: any;

  visible?: boolean;

  hideDownloadExample?: boolean;

  step?: Step;
  filecontent?: IFileContent

  resultado?: ImportResultFinal;

  final?: ImportFinal;

  openDetail?: ImportResult;
}

class Index extends React.Component<IProps, IState> {
  state : IState = { step: Step.LoadFile }
  componentDidMount = () => Index.getDerivedStateFromProps(this.props, this.state);
  static getDerivedStateFromProps = (p: IProps, s?: IState) : IState => {
    let res : IState = { };
    if (p?.storage !== s?.storage) res.storage = p.storage;
    if (p?.visible !== s?.visible) res.visible = p.visible;
    if (p?.entity !== s?.entity) res.entity = p.entity;
    if (p?.extraData !== s?.extraData) res.extraData = p.extraData;
    if (p?.hideDownloadExample !== s?.hideDownloadExample) res.hideDownloadExample = p.hideDownloadExample;
    return res;
  }

  downloadModel = () => {
    const { overrideOnDownloadExample } = this.props;
    const { entity, extraData } = this.state;

    if (!!overrideOnDownloadExample) return overrideOnDownloadExample(entity, extraData); // override
    
    API.importador().getCSVModel({ entity })
      .then(res => {
        Alert.reponse(res);
        if (res.success) {
          var blob = new Blob([res.data ?? ''], { type: 'text/csv;charset=utf-8' });
          saveAs(blob, `${entity}.csv`);
        }
      })
  }

  /** sube el archivo y testea la importación */
  upload = () => {
    const { filecontent, entity, extraData } = this.state;
    const t = Translate.get(DiccionaryKey, this.state.storage?.languaje);

    if (!filecontent || !entity) {
      Alert.error(t("Error.Titulo"), t("Error.FileNotSelected"));
      return;
    }

    this.setState({ step: Step.LoadingFile, resultado: undefined }, () => {
      API.importador().test({ entity, extraDataJson: JSON.stringify(extraData ?? '{}'), content: filecontent })
        .then(dto => {
          if (!dto.success || !dto.data) {
            Alert.reponse(dto);
            this.setState({ step: Step.LoadFile })
            return;
          }
          this.setState({ step: Step.ShowImported, resultado: dto.data })
        }).catch(ex => {
          Alert.error(t("Error.Titulo"), `${ex}`)
          this.setState({ step: Step.LoadFile })
        })
    })
  }

  /** Acepta la importación y la manda a aplicar */
  procesar = () => {    
    const { filecontent, entity, extraData } = this.state;
    const t = Translate.get(DiccionaryKey, this.state.storage?.languaje);

    if (!filecontent || !entity) {
      Alert.error(t("Error.Titulo"), t("Error.FileNotSelected"));
      return;
    }

    this.setState({ step: Step.Processing }, () => {
      API.importador().importar({ entity, extraDataJson: JSON.stringify(extraData ?? '{}'), content: filecontent })
        .then(dto => {
          if (!dto.success || !dto.data) {
            Alert.reponse(dto);
            this.setState({ step: Step.LoadFile })
          }
          this.setState({ step: Step.Result, final: dto.data })
        }).catch(ex => {
          Alert.exception(t, ex);
          this.setState({ step: Step.LoadFile })
        })
    })
  }

  render() {
    const { step, visible, filecontent, resultado, openDetail, final } = this.state;
    const { onHide } = this.props;
    const t = Translate.get(DiccionaryKey, this.state.storage?.languaje);

    let calcStepIndex = step === Step.LoadFile || step === Step.LoadingFile ? 0 : ( step === Step.ShowImported || step === Step.Processing ? 1 : 2 );

    return <>
      <Dialog 
        visible={visible} onHide={() => onHide(step === Step.Result)} dismissableMask 
        header={<><i className='fas fa-upload' /> {t("Title")}</>}
        style={{ width: '90%', height: '90%', minWidth: 350 }}
      >
        <Steps 
          style={{ marginBottom: 15 }} readOnly={true}
          model={[
            { label: t("Step.LoadFile") },
            { label: t("Step.ShowImported") },
            { label: t("Step.Result") },
          ]}
          activeIndex={calcStepIndex}
        />

        {/** CARGAR ARCHIVO */}

        {step === Step.LoadFile && <>
          <div className='hseparator' />
          {!this.state.hideDownloadExample && <>
            <Button label={t("DescargarModelo")} icon="fas fa-download" className='p-button-outlined p-button-secondary' onClick={() => this.downloadModel()} />
            <div className='hseparator' />
            <div className='hseparator' />
          </>}
          <Forms.UploadSingleFile maxSize={10000} title={t("Col.file")} placeholder={t("Col.file.Placeholder")} accept=".csv" value={filecontent} onChange={(filecontent, e) => this.setState({ filecontent})} />
          <div className='hseparator' />
          <Button label={t("Procesar")} icon="fas fa-upload" disabled={!filecontent} onClick={() => this.upload()} />
        </>}
        {step === Step.LoadingFile && <>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Loader loading>
              <img src="/images/importando.png" alt={t("Procesar")} />
            </Loader>
          </div>
        </>}


        {/** MOSTRAR RESULTADOS DEL TESTEO */}

        {step === Step.ShowImported && <>
          <Button label={t("Procesar.Volver")} icon="fas fa-angle-left" className='p-button-text p-button-secondary' onClick={() => this.setState({ step: Step.LoadFile, resultado: undefined, filecontent: undefined })}  />
          <div className='hseparator' />
          <DataTable value={(resultado?.results ?? []).sort((a,b) => !!(hasError(a)) ? -1 : (a.index > b.index ? 1 : 0)).filter((v,i) => i < 200)} className={styles["grid"]}>
            <Column 
              field='status'
              style={{ width: 36 }}
              filter={false} sortable={false} 
              body={(row : ImportResult) => {
                let icon = "fas fa-minus";
                let classname = "p-button-sm p-button-rounded p-button-secondary p-button-text";
                let tooltip = "Procesar.Estado.NONE";
                if (hasError(row)) { tooltip="Procesar.Estado.ERROR"; icon="fas fa-exclamation-triangle"; classname='p-button-sm p-button-rounded p-button-danger p-button-text' }
                else if (hasWarn(row)) { tooltip="Procesar.Estado.WARN"; icon="fas fa-exclamation"; classname='p-button-sm p-button-rounded p-button-warning p-button-text' }
                else if (row.action?.action === 'INS' || row.action?.action === ImportActionsMS.INS) { tooltip="Procesar.Estado.INS"; icon="fas fa-plus"; classname='p-button-sm p-button-rounded p-button-success p-button-text' }
                else if (row.action?.action === 'UPD' || row.action?.action === ImportActionsMS.UPD) { tooltip="Procesar.Estado.UPD"; icon="fas fa-pen"; classname='p-button-sm p-button-rounded p-button-primary p-button-text' }
                return <Button icon={icon} tooltip={t(tooltip)} tooltipOptions={{ position: 'right' }} className={classname} style={{ width: 28, height: 28, padding: 0 }} onClick={() => this.setState({ openDetail: row })} />
              }}
            />

            {resultado?.fields.map((field, indexField) => 
              <Column 
                header={t(field)} 
                filter={false} sortable={false} 
                body={(row : ImportResult) => {
                  let show = '';
                  if (hasErrorOrWarn(row)) {
                    if (!!row.data) show = (row.data[indexField].show ?? row.data[indexField].original ?? ''); else show = '';
                  } else if (!!row.data) {
                    show = row.data[indexField].show ?? row.data[indexField].valor;
                  }
                  let color = 'var(--secondary)';
                  if (hasError(row)) color = 'var(--danger)'
                  else if (hasWarn(row)) color = 'var(--warning)'
                  else if (row.action?.action === 'INS' || row.action?.action === ImportActionsMS.INS) color = 'var(--success)'
                  else if (row.action?.action === 'UPD' || row.action?.action === ImportActionsMS.UPD) color = 'var(--primary)'
  
                  return <div style={{ color }}>{show}</div>}
                }
              />
            )}
          </DataTable>
          <div className='hseparator' />
          {(() => {
            console.log("-hayerrores-", resultado?.results);

            const hayerrores = !!resultado?.results.find(p => (p.errors?.filter(e => !!e.error).length ?? 0) > 0);
            console.log("error? donde", resultado?.results.find(p => (p.errors?.filter(e => !!e.error).length ?? 0) > 0))
            return <div style={{ display: 'flex', flexDirection: 'column' }}>
              <Button label={t("Importar")} icon="pi pi-save" disabled={hayerrores} onClick={() => this.procesar()} />
              {hayerrores && <div style={{ fontSize: 12, color: 'var(--danger)' }}>{t("Importar.Disabled")}</div>}
            </div>
          })()}
        </>}
        {step === Step.Processing && <>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Loader loading>
              <img src="/images/building.png" alt={t("Procesar")} />
            </Loader>
          </div>
        </>}

        {/** MOSTRAR RESULTADOS FINALES */}
        {step === Step.Result && <>
          <div className={styles["final-card-container"]}>
            <div className={styles["final-card"]}>
              <div className={styles["final-card-header"]}>
                <b>{t("Final.Exitoso.Message")}</b>
              </div>
              <div className={styles["final-card-body"]}>
                <div className={styles["final-card-body-row"]}>
                  <i className='fas fa-plus' style={{ color: 'var(--success)' }} />
                  <div>{t("Final.Inserteds")}:</div>
                  <div style={{ fontWeight: 800 }}>{final?.inserteds}</div>
                </div>
                <div className={styles["final-card-body-row"]}>
                  <i className='fas fa-pen' style={{ color: 'var(--primary)' }} />
                  <div>{t("Final.Updateds")}:</div>
                  <div style={{ fontWeight: 800 }}>{final?.updateds}</div>
                </div>
              </div>
              <Button label={t("Close")} tooltip={t("Close.Tooltip")} className='p-button-secondary' onClick={() => this.setState({ step: Step.LoadFile, filecontent: undefined, resultado: undefined, final: undefined, openDetail: undefined }, () => this.props.onHide(true)) } />
            </div>
          </div>
        </>}

      </Dialog>
      
      {/** DETALLES */}
      <Dialog 
        visible={!!openDetail} onHide={() => this.setState({ openDetail: undefined })} dismissableMask 
        header={<><i className='fas fa-info' /> {t("Detail.Title")}</>}
        style={{ width: '60%', minWidth: 350 }}
      >
        <DataTable value={resultado?.fields?.map((p,i) => ({ i, show: p }))}>
          <Column header={t("Detail.Campo")} filter={false} sortable={false} body={row => <>{t(row.show)}</>} />
          <Column 
            header={t("Detail.Original")}
            filter={false} sortable={false} 
            body={row => {
              const data = openDetail?.data ? openDetail!.data[row.i] : undefined;
              return <>{data?.original}</>
            }}
          />
          <Column 
            header={t("Detail.Final")}
            filter={false} sortable={false} 
            body={row => {
              const data = openDetail?.data ? openDetail!.data[row.i] : undefined;
              return <>{data?.show ?? data?.valor}</>
            }}
          />
        </DataTable>
        <div className='hseparator' />
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {openDetail?.errors?.map(er => 
            <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
              <div style={{ width: 24, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                {!!er.warn && <i className='fas fa-exclamation' style={{ color: 'var(--warning)' }} />}
                {!!er.error && <i className='fas fa-exclamation-triangle' style={{ color: 'var(--danger)' }} />}
              </div>
              <div>
                {!!er.error && t(er.error, er.params)}
                {!!er.warn && t(er.warn, er.params)}
              </div>
            </div>
          )}
        </div>
        <div className='hseparator' />
        <h4>{t("Detail.Bruto.Title")}</h4>
        <div style={{ width: '100%', border: '1px solid var(--background-work-border)', borderRadius: 5, background: 'var(--background-work-hover)', color: 'var(--color)', padding: '10px 12px', fontFamily: 'monospace', fontSize: 12 }}>
          {openDetail?.row}
        </div>
        <div className='hseparator' />
      </Dialog>
    </>;
  }
}

const hasErrorOrWarn = (res: ImportResult) => (res?.errors?.length ?? 0) >= 0;
const hasError = (res: ImportResult) => !!(res?.errors?.find(p => !!p.error) ?? false);
const hasWarn = (res: ImportResult) => !!(res?.errors?.find(p => !!p.warn) ?? false);

export default connect((s:any) => ({ storage:s.main }))(Index);

export { ImporterListado } from './listado';